import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';

/**
 * Generated class for the PopupadddriverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popupadddriver',
  templateUrl: 'popupadddriver.html',
})
export class PopupadddriverPage {
  vehicleid = 0
  leftdrivers: any

  Group = []
  loadingData: boolean = true
  GroupElements = 0;

  selectedArray = []
  checkallVeh: boolean
  checkOrg: boolean
  countVisible = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {

    this.leftdrivers = navParams.get('leftdrivers')

    this.vehicleid = navParams.get('vehicleid')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PopupadddriverPage');
    this.loadData()
  }

  loadData() {
    var _that = this
    this.gn._Post('/api/gn/admin/getorg', { clientid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _data.push({ id: 0, name: _that.dic.l["Ungroupped"] })
      _that.Group = []
      for (var i = 0; i < _data.length; i++) {
        _that.Group.push({ id: _data[i].id, name: _data[i].name, drivers: [] })
        for (var j = 0; j < _that.leftdrivers.length; j++) {
          if (_that.leftdrivers[j].organisationid == _data[i].id) {
            _that.Group[_that.Group.length - 1].drivers.push(_that.leftdrivers[j])
            _that.GroupElements++;
          }
        }
      }
      _that.resetSearch()
      _that.loadingData = false
    })
  }

  checkAll() {
    for (let i = 0; i <= this.leftdrivers.length; i++) {
      this.leftdrivers[i].checked == true;
    }

  }

  selectMember(data) {
    if (data.checked == true) {
      this.selectedArray.push(data.id);
    }
    else {
      for (let i = 0; i < this.selectedArray.length; i++) {
        if (this.selectedArray[i] == data.id) {
          this.selectedArray.splice(i, 1);
        }
      }
    }
  }


  selectAll() {
    this.checkallVeh = !this.checkallVeh
    if (this.checkallVeh == false) {
      this.selectedArray = []
      for (let i = 0; i < this.leftdrivers.length; i++) {
        this.leftdrivers[i].checked = false;
      }
      for (let i = 0; i < this.Group.length; i++) {
        if (this.Group[i].drivers.length > 0) {
          this.Group[i].checked = false;
        }
      }
    }
    if (this.checkallVeh == true) {
      for (let i = 0; i < this.leftdrivers.length; i++) {
        this.selectedArray.push(this.leftdrivers[i].id)
        this.leftdrivers[i].checked = true;
      }
      for (let i = 0; i < this.Group.length; i++) {
        if (this.Group[i].drivers.length > 0) {
          this.Group[i].checked = true;
        }
      }
    }
  }

  checkOrganisation() {
    for (let i = 0; i <= this.Group.length; i++) {
      this.Group[i].checked == true;
    }
  }

  selectOrg(a: any) {
    if (a.checked == true) {
      for (let i = 0; i < a.drivers.length; i++) {
        this.selectedArray.push(a.drivers[i].id);
        for (let m = 0; m < this.leftdrivers.length; m++) {
          if (a.drivers[i].id == this.leftdrivers[m].id)
            this.leftdrivers[m].checked = true;
        }
      }

    }
    else {
      for (let y = 0; y < a.drivers.length; y++) {
        for (let l = 0; l < this.selectedArray.length; l++) {
          if (this.selectedArray[l] == a.drivers[y].id) {
            this.selectedArray.splice(l, 1);
          }

        }
        for (let m = 0; m < this.leftdrivers.length; m++) {
          if (a.drivers[y].id == this.leftdrivers[m].id) {
            this.leftdrivers[m].checked = false;
          }
        }
      }
    }
  }


  resetSearch() {
    for (var i = 0; i < this.Group.length; i++) {
      this.Group[i].Visible = true
      this.Group[i].countShow = 0;

      for (let j = 0; j < this.Group[i].drivers.length; j++) {
        this.Group[i].drivers[j].Visible = true;
      }
    }
  }

  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchVehLeft(val);

  }

  searchVehLeft(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.Group.length; i++) {
        var countshowvehicles = 0;
        for (let j = 0; j < this.Group[i].drivers.length; j++) {
          if (this.Group[i].drivers[j].code.indexOf(val) > -1) {
            this.Group[i].drivers[j].Visible = true
            this.Group[i].Visible = true;
          }
          else {
            if (this.gn._latcyr(this.Group[i].drivers[j].fullname.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.Group[i].drivers[j].fullname.toLowerCase()).indexOf(val) > -1) {
              this.Group[i].drivers[j].Visible = true
              this.Group[i].Visible = true;
            }

            else {
              this.Group[i].drivers[j].Visible = false
              this.Group[i].Visible = false;
              this.countVisible++;
              countshowvehicles++;
            }
          }
          this.Group[i].countShow = countshowvehicles
        }
      }
    }
    else {
      this.resetSearch()
    }
  }

  Save() {


    var _cb = this.navParams.get('cb')
    _cb(this.selectedArray)
    this.navCtrl.pop()



  }

  ionViewWillUnload() {
    this.selectedArray = []
    for (let m = 0; m < this.leftdrivers.length; m++) {
      this.leftdrivers[m].checked = false;
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/settings/vehiclesettinngs/popupadddriver/popupadddriver.ts